import React from "react";

const Contact = () => {
    return (
        <div>
            <h1>Contact Us</h1>
            <p>Get in touch with us for any inquiries.</p>
        </div>
    );
};

export default Contact;
